<template>
    <div class="guest-wrapper register-wrapper">
        <div class="guest-logo">
            <img src="/images/new_logo_v2.png" width="220"/>
        </div>
        <div class="row">
            <div class="col-md-6 col-xs-12 ml-auto mr-auto mt-5">
                <div class="card card-white">
                    <div class="card-body">
                        <div class="col-12 alert alert-danger">
                            <h4 class="text-white">Hi {{ user.first_name }}, your account application has been rejected.</h4>
                            <p class="text-white">We regret to inform you that your account application is unsuccessful. If you have any queries, please do not hesitate to contact us at contact@capsphere.com.my.</p>
                            <p class="text-white mt-2">Thank you.</p>
                        </div>

                        <a href="#" v-on:click="logout" class="btn btn-block mt-5 btn-secondary">Log Out</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import jwtToken from '../helpers/jwt-token';
  import { api, siteName } from '../config'
  import eventUuid from "../helpers/event-uuid";

  export default {
    name: "ApplicationRejected",
    data () {
      return {
        user: null,
      }
    },

    created () {
      if (this.$store.state.auth) {
        this.user = this.$store.state.auth;
      }
    },

    mounted () {

    },

    methods : {
      logout () {
        axios.post(api.logout, {
            eventUuid: eventUuid.getEventUuid()
        })
          .then((res) => {
            this.$router.push({'name' : 'login'}); // go to login page

            this.$store.dispatch('unsetAuthUser')
              .then(() => {
                jwtToken.removeToken();
                eventUuid.removeEventUuid();
                this.$noty.success('You are logged out');
                this.$router.push({name: 'login'});
              });
          })
          .catch((err) => {
            this.$noty.error('Something went wrong, unable to logout')
          })
      }
    }
  }
</script>

<style scoped>

</style>